import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, TextField, Box } from '@mui/material';
import { getDeviceThresholds } from '../API/deviceThresholds';

const WaterConfigSection = ({ waterDevices, onThresholdsChange }) => {
  const [deviceValues, setDeviceValues] = useState({});
  const [loading, setLoading] = useState(true);

  const loadThresholds = useCallback(async () => {
    if (!waterDevices || waterDevices.length === 0) return;

    setLoading(true);
    const newValues = {};

    try {
      for (const device of waterDevices) {
        try {
          const response = await getDeviceThresholds(device.dev_eui);
          const thresholds = response.thresholds || [];

          let yellowValue = 150;
          let redValue = 200;

          const yellowThreshold = thresholds.find(t => t.threshold_type === 'yellow');
          const redThreshold = thresholds.find(t => t.threshold_type === 'red');

          if (yellowThreshold) yellowValue = yellowThreshold.threshold_value;
          if (redThreshold) redValue = redThreshold.threshold_value;

          newValues[device.dev_eui] = {
            yellow: yellowValue,
            red: redValue
          };
        } catch (error) {
          // Pas de seuils existants, utilisation valeurs par défaut
          newValues[device.dev_eui] = {
            yellow: 150,
            red: 200
          };
        }
      }

      setDeviceValues(newValues);
      onThresholdsChange?.(newValues);
    } catch (error) {
      // Erreur silencieuse
    } finally {
      setLoading(false);
    }
  }, [waterDevices, onThresholdsChange]);

  useEffect(() => {
    loadThresholds();
  }, [loadThresholds]);

  const handleValueChange = (deviceEui, type, value) => {
    const newValues = {
      ...deviceValues,
      [deviceEui]: {
        ...deviceValues[deviceEui],
        [type]: parseFloat(value) || 0
      }
    };
    setDeviceValues(newValues);
    onThresholdsChange?.(newValues);
  };

  if (!waterDevices || waterDevices.length === 0) return null;
  if (loading) return <div>Chargement des seuils eau...</div>;

  return (
    <Card sx={{ mt: 3 }}>
      <CardHeader 
        title="Configuration Seuils Eau" 
        subheader="Modifiez les seuils puis utilisez le bouton METTRE À JOUR en bas de page pour sauvegarder."
      />
      <CardContent>
        {waterDevices.map((device) => (
          <Box key={device.dev_eui} sx={{ mb: 3, p: 2, border: '1px solid #ddd', borderRadius: 1 }}>
            <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>
              {device.name} ({device.brand_name})
            </div>
            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
              <TextField 
                label="Seuil Jaune (L)" 
                type="number" 
                value={deviceValues[device.dev_eui]?.yellow || 150}
                onChange={(e) => handleValueChange(device.dev_eui, 'yellow', e.target.value)}
                size="small"
              />
              <TextField 
                label="Seuil Rouge (L)" 
                type="number" 
                value={deviceValues[device.dev_eui]?.red || 200}
                onChange={(e) => handleValueChange(device.dev_eui, 'red', e.target.value)}
                size="small"
              />
            </Box>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default WaterConfigSection;
